import { Injectable } from "@angular/core";
import { TranslateDto } from "../../models/translate/translate.dto";
import { WorkplaceStorageService } from "../../services/local/workplaces-storage.service";
import { FormOrgLangDto } from "../../models/configuration/forms/form-org-lan.dto";
import { JSONHelper } from "./json.helper";
import { CatUserLoginService } from "../../services/hospital-infrastructure/catalog-user-login.service";
import { SendInfoComponentService } from "../../services/local/send-info.component.service";
import { StringUtilsHelper } from "./strings.helper";
import { NavigationHelper } from "./navigation.helper";
import { Router } from "@angular/router";
import { LabelsTranslationConstants } from "../../constants/labels-translation.constants";
import { lastValueFrom } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class TranslateHelper {
    static userLoginServiceStatic: CatUserLoginService;
    static nav: Router;
    constructor(readonly userLoginService: CatUserLoginService, readonly sendLanguageChange: SendInfoComponentService, readonly router: Router) {
        TranslateHelper.userLoginServiceStatic = userLoginService;
        TranslateHelper.nav = router;
    }

    static initialize() {
        console.log("initialize")
    }

    static getTranslation(formUrl: string, withHeader?: boolean): TranslateDto{
        let list = this.getListMap(formUrl);
        if (withHeader) {
            const lsForm2 = this.getTranslation("home");
            lsForm2.lbl.forEach((value, key) => {
                list.lbl.set(key, value);
            });
        }
        return list;
    }

    private static getListMap(formUrl: string): TranslateDto{
        let form = this.existForm(formUrl);
        let obj: TranslateDto = {
            language: "",
            lbl: new Map(),
            ph: new Map(),
            msg: new Map()
        };
        if (form !== undefined) {
            obj = this.getLblForm(form);
        }
        return obj;
    }

    private static getLblForm(option : FormOrgLangDto){
        let list: TranslateDto = {} as TranslateDto;
        let obj = JSON.parse(option.labels);
        let screensObj: any;
        if (obj.screens_lock) {
            screensObj = obj.screens_lock[0];
        } else {
            screensObj = obj.screens[0];
        }
        list.lbl = TranslateHelper.createListTraduction(screensObj, "labels");
        list.ph = TranslateHelper.createListTraduction(screensObj, "placeholders");
        list.msg = TranslateHelper.createListTraduction(screensObj, "messages");
        return list;
    }

    static createListTraduction(obj: any, key: string){
        let list = JSONHelper.getDataByKey(obj, key);
        let map = new Map<string, string>();
        if(list === undefined || list === null) return map;
        list.forEach((element: any) => {
            map.set(element.slug.toLowerCase(), JSONHelper.getDataByKey(element, key.substring(0, key.length - 1)));
        });
        return map;
    }

    static getLabels(list: Map<string, string>, ... keys: string[]): string[] {
        let labels: string[] = [];
        if(list != null){
            keys.forEach((key: string) => {
                labels.push(list.get(key));
            });
        }
        return labels;
    }

    static addTranslateForm(form: FormOrgLangDto){
        let list: FormOrgLangDto[] = WorkplaceStorageService.getForms();
        if (StringUtilsHelper.notNullOrUndefinedOrEmpty(list) && list.length > 0) {
            let exist = list.find(x => x.url === form.url);
            if(!StringUtilsHelper.notNullOrUndefinedOrEmpty(exist))
                list.push(form);
        } else {
            list = [ form ];
        }
        WorkplaceStorageService.saveObjTraduction(JSON.stringify(list));
    }

    static existForm(url: string){
        let list: FormOrgLangDto[] = WorkplaceStorageService.getForms();
        let exist = list.find(x => x.url === url);
        let form: FormOrgLangDto;
        if (StringUtilsHelper.notNullOrUndefinedOrEmpty(exist))
            form = WorkplaceStorageService.getFormId(url);
        return form;
    }

    static deleteForm(url: string){
        let array = NavigationHelper.getUrlBySegment(url);
        let list: FormOrgLangDto[] = WorkplaceStorageService.getForms();
        let listForm = list.filter(x => !x.url.includes(array[array.length -1]));
        WorkplaceStorageService.saveObjTraduction(JSON.stringify(listForm));
    }

    async getFormTranslateByUrl(url: string, urlComplete: string, navigate: boolean = true){
        this.userLoginService.getFormsByUrl(WorkplaceStorageService.getLanguageCve(), WorkplaceStorageService.getBranchIdData(), url)
                .subscribe(form => {
                    if(StringUtilsHelper.notNullOrUndefinedOrEmpty(form) && form.length > 0){
                        form.forEach(elem => {
                            TranslateHelper.addTranslateForm(elem);
                            this.checkNestedUrls(elem.url);
                        });
                    }
                    if(StringUtilsHelper.notNullOrUndefinedOrEmpty(urlComplete) && navigate)
                        this.router.navigate([urlComplete]);
                });
    }

    getListCommonTraduction(){
        this.getTranslationTags("home", true);
        this.getTranslationTags("table", true);
        this.getTranslationTags("locksession", true);
        this.getTranslationTags("signature", true);
        this.getTranslationTags('loading', false);
    }

    public async getTranslationTags(url: string, isCommon?: boolean) {
        const form = await lastValueFrom(
            this.userLoginService.getFormsByUrl(
                WorkplaceStorageService.getLanguageCve(),
                WorkplaceStorageService.getBranchIdData(),
                url
            )
        );
        this.setFormTranslate(form, isCommon);
    }

    private setFormTranslate(form: FormOrgLangDto[], isCommon: boolean){
        if(StringUtilsHelper.notNullOrUndefinedOrEmpty(form) && form.length > 0){
            if (isCommon) {
                TranslateHelper.addTranslateForm(form[0]);
            } else {
                form.forEach(elem => {
                    TranslateHelper.addTranslateForm(elem);
                });
            }
        }
    }

    private checkNestedUrls(url: string){
        const nestedUrls = LabelsTranslationConstants;
        let urlArray = NavigationHelper.getUrlBySegment(url);
        let array: any[] = [];

        if (urlArray.length > 0) {
            let dataObj: any;
            urlArray.forEach(seg => {
                dataObj = StringUtilsHelper.notNullOrUndefinedOrEmpty(dataObj) ? JSONHelper.getDataByKey(dataObj, seg) : JSONHelper.getDataByKey(nestedUrls, seg);
                if(StringUtilsHelper.notNullOrUndefinedOrEmpty(dataObj)){
                    if(Array.isArray(dataObj)){
                        array = dataObj;
                    }
                }
            });
        }
        //Get translation tags
        array.forEach(u => {
            this.getTranslationTags(u);
        });
    }

    updateListTraduction(orgId: number){
        this.userLoginService.getFormsByLanCveAndIdOrg(WorkplaceStorageService.getLanguageCve(), orgId).subscribe(element => {
            WorkplaceStorageService.saveObjTraduction(JSON.stringify(element));
            this.sendLanguageChange.sendObject(WorkplaceStorageService.getLanguageCve(), "traduction");
        });
    }
}
